import { gql } from "@apollo/client";

/**
 * One-time assignment of a citation's session transaction to a fleet operator
 * after review (AUT-5033). The backend enforces immutability: a second
 * assignment attempt returns a conflict error.
 */
export const ASSIGN_ENFORCEMENT_INTENT_OPERATOR = gql`
  mutation AssignEnforcementIntentOperator($intentId: uuid!, $operatorAccountId: uuid!) {
    assign_enforcement_intent_operator(enforcement_intent_id: $intentId, operator_account_id: $operatorAccountId) {
      enforcementIntentId: enforcement_intent_id
      transactionId: transaction_id
      operatorAccountId: operator_account_id
      assignedAt: assigned_at
    }
  }
`;

export interface AssignEnforcementIntentOperatorData {
  assign_enforcement_intent_operator: {
    enforcementIntentId: string;
    transactionId: string;
    operatorAccountId: string;
    assignedAt: string | null;
  };
}

export interface AssignEnforcementIntentOperatorVars {
  intentId: string;
  operatorAccountId: string;
}

export default ASSIGN_ENFORCEMENT_INTENT_OPERATOR;
